<app-webpage-analytics></app-webpage-analytics>

<div class="flex">
    <div class="ontario-row recordContainer">

        <app-breadcrumbs></app-breadcrumbs>

        <div class="divider">
            <h1> {{ mdi_ident }} </h1>
        </div>

        <app-copy-to-clipboard [index]="databaseIndex" [fileNumber]="mdi_ident"></app-copy-to-clipboard>

        <ng-template [ngTemplateOutlet]="detailsTable"></ng-template>

        <div class="ontario-accordions__container">
            <div class="ontario-accordion__controls">
                <button class="ontario-accordion__button--expand-all" aria-expanded="false">
                    <span class="ontario-accordion--expand-open-all">{{ 'expand.all' | translate | async }}</span>
                    <span class="ontario-accordion--expand-close-all">{{ 'collapse.all' | translate | async }}</span>
                </button>
            </div>
            <div class="ontario-accordion" id="accordion-1">
                <button class="ontario-accordion__button" id="accordion-button-id-1" aria-controls="accordion-content-1"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>{{ 'commodities' | translate | async }}</h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-1" aria-labelledby="accordion-button-id-1" aria-hidden="true" data-toggle="ontario-expander-content">
                    <ng-template [ngTemplateOutlet]="commoditiesDetails"></ng-template>
                </section>
            </div>
            <div class="ontario-accordion" id="accordion-2">
                <button class="ontario-accordion__button" id="accordion-button-id-2" aria-controls="accordion-content-2"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>{{ 'location' | translate | async }}</h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-2" aria-labelledby="accordion-button-id-2" aria-hidden="true" data-toggle="ontario-expander-content">
                    <ng-template [ngTemplateOutlet]="locationDetails"></ng-template>
                </section>
            </div>
            <div *ngIf="exploration_history" class="ontario-accordion" id="accordion-3">
                <button class="ontario-accordion__button" id="accordion-button-id-3" aria-controls="accordion-content-3"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>{{ 'exploration.history' | translate | async }}</h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-3" aria-labelledby="accordion-button-id-3" aria-hidden="true" data-toggle="ontario-expander-content">
                    <ng-template [ngTemplateOutlet]="explorationHistoryDetails"></ng-template>
                </section>
            </div>
            <div *ngIf="assessment_works" class="ontario-accordion" id="accordion-4">
                <button class="ontario-accordion__button" id="accordion-button-id-4" aria-controls="accordion-content-4"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>{{ 'assessment.work.on.file' | translate | async }}</h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-4" aria-labelledby="accordion-button-id-4" aria-hidden="true" data-toggle="ontario-expander-content">
                    <ng-template [ngTemplateOutlet]="assessmentWorkTable"></ng-template>
                </section>
            </div>

            <div *ngIf="province || subprovince || terrane || domain || belt || tectonic_assemblage || geological_age || metamorphism_type || metamorphism_grade || formation_group || supergroup || geochronological_age || geochronological_age_ref" class="ontario-accordion" id="accordion-5">
                <button class="ontario-accordion__button" id="accordion-button-id-5" aria-controls="accordion-content-5"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>{{ 'geology' | translate | async }}</h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-5" aria-labelledby="accordion-button-id-5" aria-hidden="true" data-toggle="ontario-expander-content">
                    <ng-template [ngTemplateOutlet]="geologyDetails"></ng-template>
                </section>
            </div>
            <div *ngIf="lithology || lithologyCommentList.length > 0" class="ontario-accordion" id="accordion-6">
                <button class="ontario-accordion__button" id="accordion-button-id-6" aria-controls="accordion-content-6"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>{{ 'lithology' | translate | async }}</h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-6" aria-labelledby="accordion-button-id-6" aria-hidden="true" data-toggle="ontario-expander-content">
                    <ng-template [ngTemplateOutlet]="lithologyTable"></ng-template>
                </section>
            </div>
            <div *ngIf="mineralization || mineralizationCommentList.length > 0" class="ontario-accordion" id="accordion-7">
                <button class="ontario-accordion__button" id="accordion-button-id-7" aria-controls="accordion-content-7"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>{{ 'mineralization' | translate | async }}</h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-7" aria-labelledby="accordion-button-id-7" aria-hidden="true" data-toggle="ontario-expander-content">
                    <ng-template [ngTemplateOutlet]="mineralizationTable"></ng-template>
                </section>
            </div>
            <div *ngIf="assay_sample" class="ontario-accordion" id="accordion-8">
                <button class="ontario-accordion__button" id="accordion-button-id-8" aria-controls="accordion-content-8"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>{{ 'assay.samples' | translate | async }}</h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-8" aria-labelledby="accordion-button-id-8" aria-hidden="true" data-toggle="ontario-expander-content">
                    <ng-template [ngTemplateOutlet]="assaySamplesTable"></ng-template>
                </section>
            </div>
            <div *ngIf="classifications" class="ontario-accordion" id="accordion-9">
                <button class="ontario-accordion__button" id="accordion-button-id-9" aria-controls="accordion-content-9"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>{{ 'classification' | translate | async }}</h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-9" aria-labelledby="accordion-button-id-9" aria-hidden="true" data-toggle="ontario-expander-content">
                    <ng-template [ngTemplateOutlet]="classificationTable"></ng-template>
                </section>
            </div>
            <div *ngIf="characteristics" class="ontario-accordion" id="accordion-10">
                <button class="ontario-accordion__button" id="accordion-button-id-10" aria-controls="accordion-content-10"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>{{ 'characteristics' | translate | async }}</h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-10" aria-labelledby="accordion-button-id-10" aria-hidden="true" data-toggle="ontario-expander-content">
                    <ng-template [ngTemplateOutlet]="characteristicsTable"></ng-template>
                </section>
            </div>
            <div *ngIf="mineralZones" class="ontario-accordion" id="accordion-11">
                <button class="ontario-accordion__button" id="accordion-button-id-11" aria-controls="accordion-content-11"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>{{ 'mineral.zones.size.shape' | translate | async }}</h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-11" aria-labelledby="accordion-button-id-11" aria-hidden="true" data-toggle="ontario-expander-content">
                    <ng-template [ngTemplateOutlet]="mineralZoneTable"></ng-template>
                </section>
            </div>
            <div *ngIf="site_visits" class="ontario-accordion" id="accordion-12">
                <button class="ontario-accordion__button" id="accordion-button-id-12" aria-controls="accordion-content-12"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>{{ 'site.visit.information' | translate | async }}</h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-12" aria-labelledby="accordion-button-id-12" aria-hidden="true" data-toggle="ontario-expander-content">
                    <ng-template [ngTemplateOutlet]="siteVisitDetails"></ng-template>
                </section>
            </div>
            <div *ngIf="reserves" class="ontario-accordion" id="accordion-13">
                <button class="ontario-accordion__button" id="accordion-button-id-13" aria-controls="accordion-content-13"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>{{ 'reserves.or.resources' | translate | async }}</h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-13" aria-labelledby="accordion-button-id-13" aria-hidden="true" data-toggle="ontario-expander-content">
                    <ng-template [ngTemplateOutlet]="reservesTable"></ng-template>
                </section>
            </div>
            <div *ngIf="production" class="ontario-accordion" id="accordion-14">
                <button class="ontario-accordion__button" id="accordion-button-id-14" aria-controls="accordion-content-14"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>{{ 'production' | translate | async }}</h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-14" aria-labelledby="accordion-button-id-14" aria-hidden="true" data-toggle="ontario-expander-content">
                    <ng-template [ngTemplateOutlet]="productionTable"></ng-template>
                </section>
            </div>
            <div *ngIf="references" class="ontario-accordion" id="accordion-15">
                <button class="ontario-accordion__button" id="accordion-button-id-15" aria-controls="accordion-content-15"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>{{ 'references' | translate | async }}</h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-15" aria-labelledby="accordion-button-id-15" aria-hidden="true" data-toggle="ontario-expander-content">
                    <ng-template [ngTemplateOutlet]="referencesDetails"></ng-template>
                </section>
            </div>
            <div class="ontario-accordion" id="accordion-16">
                <button class="ontario-accordion__button" id="accordion-button-id-16" aria-controls="accordion-content-16"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>
                        {{ 'report.an.error' | translate | async }}
                    </h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-16" aria-labelledby="accordion-button-id-16" aria-hidden="true" data-toggle="ontario-expander-content">
                    <div>
                        <p innerHTML="{{ 'mineral.inventory.report.an.error.text' | translate | async }}">
                            {{ 'mineral.inventory.report.an.error.text' | translate | async }}
                    </div>
                </section>
            </div>
            <div class="ontario-accordion" id="accordion-17">
                <button class="ontario-accordion__button" id="accordion-button-id-17" aria-controls="accordion-content-17"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>
                        {{ 'terms.of.use' | translate | async }}
                    </h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-17" aria-labelledby="accordion-button-id-17" aria-hidden="true" data-toggle="ontario-expander-content">
                    <div>
                        <p innerHTML="{{ 'terms.of.use.link' | translate | async }}">
                            {{ 'terms.of.use.link' | translate | async }}
                        </p>
                    </div>
                </section>
            </div>
        </div>

        <div class="mt-4 divider contactInformationContainer">
            <div class="flex mb-4 ">
                <h3 class="contactInformationTitle">
                    {{ 'contact.information' | translate | async }}
                </h3>   
                <p class="contactInformationValue">

                    {{ 'mineral.inventory.contact.text' | translate | async }}

                    <a target="_blank" 
                        href="https://www.infogo.gov.on.ca/infogo/#orgProfile/{{contact_rgp.contact}}/en">
                        {{ contact_rgp.rgp_district }}
                    </a> 
                </p> 
            </div>
        </div>

        <ng-template #detailsTable>
            <div>
                <div>
                    <h2 class="mt-3 mb-3">{{ 'mineral.inventory.file.details' | translate | async }}</h2>
                </div>
                <div class="detailsContainer">
                    <div class="flex">
                        <div class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'record.id' | translate | async }}:</p>
                            <p class="recordValue" innerHTML="{{ mdi_ident | highlight : this.searchTerms }}">
                                {{ mdi_ident | highlight : this.searchTerms }}
                            </p>
                        </div>
                        <div *ngIf="recordNames.length > 0" class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'record.name' | translate | async}}:</p>
                            <p class="recordValue" innerHTML="{{ recordNames | commaSeparatedPipe:'md_name' | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ recordNames | commaSeparatedPipe:'md_name' | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                        </div>
                        <div *ngIf="depositStatus" class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'record.status' | translate | async}}:</p>
                            <p class="recordValue" innerHTML="{{ depositStatus | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ depositStatus | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                        </div>
                        <div *ngIf="related_deposit_flag" class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'related.record.type' | translate | async}}:</p>
                            <p class="recordValue" innerHTML="{{ related_deposit_flag | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ related_deposit_flag | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                        </div>
                        <div *ngIf="realtedRecords.length > 0" class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'related.record' | translate | async}}:</p>
                            <p class="recordValue" innerHTML="{{ realtedRecords | commaSeparatedPipe:'related_deposit_mdi_ident' | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ realtedRecords | commaSeparatedPipe:'related_deposit_mdi_ident' | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                        </div>
                        <div *ngIf="create_date" class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'date.created' | translate | async}}:</p>
                            <p class="recordValue" innerHTML="{{ create_date | date: 'YYYY-MM-dd' | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ create_date | date: 'YYYY-MM-dd' | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                        </div>
                        <div *ngIf="dateLastModified" class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'date.last.modified' | translate | async}}:</p>
                            <p class="recordValue" innerHTML="{{ dateLastModified | date: 'YYYY-MM-dd' | notApplicablePipe | async }}">
                                {{ dateLastModified | date: 'YYYY-MM-dd' | notApplicablePipe | async }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #commoditiesDetails>
            <div>
                <div class="detailsContainer">
                    <div *ngIf="primary_commodities.length > 0" class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">{{ 'primary.commodity' | translate | async }}:</p>
                        <p class="recordValue" innerHTML="{{ primary_commodities | commaSeparatedPipe:'description' | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ primary_commodities | commaSeparatedPipe:'description' | notApplicablePipe | async | highlight : this.searchTerms }}
                        </p>
                    </div>
                    <div *ngIf="secondary_commodities.length > 0" class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">{{ 'secondary.commodity' | translate | async }}:</p>
                        <p class="recordValue" innerHTML="{{ secondary_commodities | commaSeparatedPipe:'description' | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ secondary_commodities | commaSeparatedPipe:'description' | notApplicablePipe | async | highlight : this.searchTerms }}
                        </p>
                    </div>
                </div>
            </div>
        </ng-template>
        
        <ng-template #locationDetails>
            <div>
                <div class="detailsContainer">
                    <div *ngIf="amis_id" class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">{{ 'amis.id' | translate | async }}:</p>
                        <p class="recordValue" innerHTML="{{ amis_id | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ amis_id | notApplicablePipe | async | highlight : this.searchTerms }}
                        </p>
                    </div>
                    <div *ngIf="townships.length > 0" class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">{{ 'township.area' | translate | async }}:</p>
                        <p class="recordValue" innerHTML="{{ townships | commaSeparatedPipe:'name' | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ townships | commaSeparatedPipe:'name' | notApplicablePipe | async | highlight : this.searchTerms }}
                        </p>
                    </div>
                    <div *ngIf="rgp_district" class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">{{ 'resident.geologist.district' | translate | async }}:</p>
                        <p class="recordValue" innerHTML="{{ rgp_district | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ rgp_district | notApplicablePipe | async | highlight : this.searchTerms }}
                        </p>
                    </div>
                    <div *ngIf="nts.length > 0" class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">{{ 'nts' | translate | async }}:</p>
                        <p class="recordValue" innerHTML="{{ nts | commaSeparatedPipe:'nts_quadrangle' | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ nts | commaSeparatedPipe:'nts_quadrangle' | notApplicablePipe | async | highlight : this.searchTerms }}
                        </p>
                    </div>
                    <div class="flex">
                        <div class="flex mb-0">
                            <p class="font-weight--bold mr-1">{{ 'longitude' | translate | async }}:</p>
                            <p innerHTML="{{ lng_dec | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ lng_dec | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                            <p class="ml-1 mr-1">{{ '|' }}</p>
                            <p class="font-weight--bold mr-1">{{ 'latitude' | translate | async }}:</p>
                            <p innerHTML="{{ lat_dec | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ lat_dec | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="flex mb-0">
                            <p class="font-weight--bold mr-1">{{ 'utm.zone' | translate | async }}:</p>
                            <p innerHTML="{{ utm_zone | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ utm_zone | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                            <p class="ml-1 mr-1">{{ '|' }}</p>
                            <p class="font-weight--bold mr-1">{{ 'easting' | translate | async }}:</p>
                            <p innerHTML="{{ utm_easting | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ utm_easting | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                            <p class="ml-1 mr-1">{{ '|' }}</p>
                            <p class="font-weight--bold mr-1">{{ 'northing' | translate | async }}:</p>
                            <p innerHTML="{{ utm_northing | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ utm_northing | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                        </div>
                    </div>
                    <div *ngIf="utm_datum" class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">{{ 'utm.datum' | translate | async }}:</p>
                        <p class="recordValue" innerHTML="{{ utm_datum | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ utm_datum | notApplicablePipe | async | highlight : this.searchTerms }}</p>
                    </div>
                    <div *ngIf="point_location_description" class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">{{ 'point.location.description' | translate | async }}:</p>
                        <p class="recordValue" innerHTML="{{ point_location_description | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ point_location_description | notApplicablePipe | async | highlight : this.searchTerms }}</p>
                    </div>
                    <div *ngIf="location_method" class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">{{ 'location.method' | translate | async }}:</p>
                        <p class="recordValue" innerHTML="{{ location_method | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ location_method | notApplicablePipe | async | highlight : this.searchTerms }}</p>
                    </div>
                    <div *ngIf="deposit_access_description" class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">{{ 'access.description' | translate | async }}:</p>
                        <p class="recordValue" innerHTML="{{ deposit_access_description | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ deposit_access_description | notApplicablePipe | async | highlight : this.searchTerms }}</p>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #explorationHistoryDetails>
            <div>
                <div class="detailsContainer">
                    <div class="flex">
                        <div class="flex mb-0">
                            <p class="recordValue" innerHTML="{{ exploration_history | highlight : this.searchTerms }}">
                                {{ exploration_history | highlight : this.searchTerms }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #assessmentWorkTable>
            <div>
                <div class="ontario-table-container">
                    <div class="ontario-table-div mb-0">
                        <table class="flex-child" tabindex="0">
                            <thead>
                                <tr>
                                    <th scope="col">{{ 'office.file.number' | translate | async }}</th>
                                    <th scope="col">{{ 'assessment.file.identifier' | translate | async }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let work of record.assessment_work">
                                    <td scope="row" innerHTML="{{ work.rgp_file_nr | highlight : this.searchTerms }}">
                                        {{ work.rgp_file_nr | highlight : this.searchTerms }}
                                    </td>
                                    <td scope="row">
                                        <ng-container *ngIf="work.file_id; else na">
                                            <a target="_blank" 
                                                innerHTML="{{ work.file_id | notApplicablePipe | async | highlight : this.searchTerms }}"
                                                href="{{this.assessmentPersistentLink}}{{work.file_id}}">
                                                {{ work.file_id | notApplicablePipe | async | highlight : this.searchTerms }}
                                            </a>                                            
                                        </ng-container>
                                        <ng-template #na>
                                            <p>{{ 'na' | translate | async }}</p>
                                        </ng-template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #geologyDetails>
            <div>
                <div class="detailsContainer">
                    <div *ngIf="province" class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">{{ 'province' | translate | async }}:</p>
                        <p class="recordValue" innerHTML="{{ province | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ province | notApplicablePipe | async | highlight : this.searchTerms }}
                        </p>
                    </div>
                    <div *ngIf="subprovince" class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">{{ 'subprovince' | translate | async }}:</p>
                        <p class="recordValue" innerHTML="{{ subprovince | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ subprovince | notApplicablePipe | async | highlight : this.searchTerms }}
                        </p>
                    </div>
                    <div *ngIf="terrane" class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">{{ 'terrane' | translate | async }}:</p>
                        <p class="recordValue" innerHTML="{{ terrane | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ terrane | notApplicablePipe | async | highlight : this.searchTerms }}
                        </p>
                    </div>
                    <div *ngIf="domain" class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">{{ 'domain' | translate | async }}:</p>
                        <p class="recordValue" innerHTML="{{ domain | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ domain | notApplicablePipe | async | highlight : this.searchTerms }}
                        </p>
                    </div>
                    <div *ngIf="belt" class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">{{ 'belt' | translate | async }}:</p>
                        <p class="recordValue" innerHTML="{{ belt | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ belt | notApplicablePipe | async | highlight : this.searchTerms }}
                        </p>
                    </div>
                    <div *ngIf="tectonic_assemblage" class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">{{ 'tectonic.assemblage' | translate | async }}:</p>
                        <p class="recordValue" innerHTML="{{ tectonic_assemblage | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ tectonic_assemblage | notApplicablePipe | async | highlight : this.searchTerms }}
                        </p>
                    </div>
                    <div *ngIf="geological_age" class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">{{ 'geological.age' | translate | async }}:</p>
                        <p class="recordValue" innerHTML="{{ geological_age | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ geological_age | notApplicablePipe | async | highlight : this.searchTerms }}
                        </p>
                    </div>
                    <div *ngIf="metamorphism_type" class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">{{ 'metamorphism.type' | translate | async }}:</p>
                        <p class="recordValue" innerHTML="{{ metamorphism_type | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ metamorphism_type | notApplicablePipe | async | highlight : this.searchTerms }}
                        </p>
                    </div>
                    <div *ngIf="metamorphism_grade" class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">{{ 'metamorphism.grade' | translate | async }}:</p>
                        <p class="recordValue" innerHTML="{{ metamorphism_grade | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ metamorphism_grade | notApplicablePipe | async | highlight : this.searchTerms }}
                        </p>
                    </div>
                    <div *ngIf="formation_group" class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">{{ 'formation.group' | translate | async }}:</p>
                        <p class="recordValue" innerHTML="{{ formation_group | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ formation_group | notApplicablePipe | async | highlight : this.searchTerms }}
                        </p>
                    </div>
                    <div *ngIf="supergroup" class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">{{ 'supergroup' | translate | async }}:</p>
                        <p class="recordValue" innerHTML="{{ supergroup | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ supergroup | notApplicablePipe | async | highlight : this.searchTerms }}
                        </p>
                    </div>
                    <div *ngIf="geochronological_age" class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">{{ 'geochronological.age' | translate | async }}:</p>
                        <p class="recordValue" innerHTML="{{ geochronological_age | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ geochronological_age | notApplicablePipe | async | highlight : this.searchTerms }}
                        </p>
                    </div>
                    <div *ngIf="geochronological_age_ref" class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">{{ 'geochronological.age.reference' | translate | async }}:</p>
                        <p class="recordValue" innerHTML="{{ geochronological_age_ref | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ geochronological_age_ref | notApplicablePipe | async | highlight : this.searchTerms }}
                        </p>
                    </div>
                    <div *ngIf="intrusion_name" class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">{{ 'intrusion.name' | translate | async }}:</p>
                        <p class="recordValue" innerHTML="{{ intrusion_name | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ intrusion_name | notApplicablePipe | async | highlight : this.searchTerms }}
                        </p>
                    </div>
                </div>
                <div *ngIf="this.geologyCommentList.length > 0">
                    <h3 class="mb-2 mt-2">
                        {{ 'geology.comments' | translate | async }}
                    </h3>
                    <div>
                        <p *ngFor="let comment of this.geologyCommentList" innerHTML="{{ comment.created_at }} ({{ comment.geologist[0].first_name | highlight : this.searchTerms }} {{ comment.geologist[0].last_name | highlight : this.searchTerms }}) - {{ comment.geology_comment | highlight : this.searchTerms }}">
                            {{ comment.created_at }} ({{ comment.geologist[0].first_name | highlight : this.searchTerms }} {{ comment.geologist[0].last_name | highlight : this.searchTerms }}) - {{ comment.geology_comment | highlight : this.searchTerms }}
                        </p>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #lithologyTable>
            <div>
                <div>
                    <div *ngIf="this.lithology">
                        <div>
                            <h3 class="mb-2">
                                {{ 'lithology.data' | translate | async }}
                            </h3>
                        </div>
                        <div class="ontario-table-container">
                            <div class="ontario-table-div mb-0">
                                <table class="flex-child" tabindex="0">
                                    <thead>
                                        <tr>
                                            <th scope="col">{{ 'rock.type' | translate | async }}</th>
                                            <th scope="col">{{ 'rank' | translate | async }}</th>
                                            <th scope="col">{{ 'composition' | translate | async }}</th>
                                            <th scope="col">{{ 'texture' | translate | async }}</th>
                                            <th scope="col">{{ 'relationship' | translate | async }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let lith of record.lithology | orderBy: 'rank'">
                                            <ng-container *ngIf="lith.rock_type && lith.rock_type.length > 0; else na">
                                                <td scope="row" innerHTML="{{ lith.rock_type[0].deposit_rock_name | highlight : this.searchTerms }}">
                                                    {{ lith.rock_type[0].deposit_rock_name | highlight : this.searchTerms }}
                                                </td>
                                            </ng-container>
                                            <ng-template #na>
                                                <td scope="row">{{ 'na' | translate | async }}</td>
                                            </ng-template>
                                            <td scope="row" innerHTML="{{ lith.rank | notApplicablePipe | async | highlight : this.searchTerms }}">
                                                {{ lith.rank | notApplicablePipe | async | highlight : this.searchTerms }}
                                            </td>
                                            <td scope="row" innerHTML="{{ lith.composition | notApplicablePipe | async | highlight : this.searchTerms }}">
                                                {{ lith.composition | notApplicablePipe | async | highlight : this.searchTerms }}
                                            </td>
                                            <td scope="row" innerHTML="{{ lith.texture | notApplicablePipe | async | highlight : this.searchTerms }}">
                                                {{ lith.texture | notApplicablePipe | async | highlight : this.searchTerms }}
                                            </td>
                                            <td scope="row" innerHTML="{{ lith.relationship | notApplicablePipe | async | highlight : this.searchTerms }}">
                                                {{ lith.relationship | notApplicablePipe | async | highlight : this.searchTerms }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="this.lithologyCommentList.length > 0">
                        <h3 class="mb-2">
                            {{ 'lithology.comments' | translate | async }}
                        </h3>
                        <div>
                            <p *ngFor="let comment of this.lithologyCommentList" innerHTML="{{ comment.created_at }} ({{ comment.geologist[0].first_name | highlight : this.searchTerms }} {{ comment.geologist[0].last_name | highlight : this.searchTerms }}) - {{ comment.geology_comment | highlight : this.searchTerms }}">
                                {{ comment.created_at }} ({{ comment.geologist[0].first_name | highlight : this.searchTerms }} {{ comment.geologist[0].last_name | highlight : this.searchTerms }}) - {{ comment.geology_comment | highlight : this.searchTerms }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #mineralizationTable>
            <div>
                <div>
                    <div *ngIf="this.mineralization">
                        <div>
                            <h3 class="mb-2">
                                {{ 'mineralization.and.alteration' | translate | async }}
                            </h3>
                        </div>
                        <div class="ontario-table-container">
                            <div class="ontario-table-div mb-0">
                                <table class="flex-child" tabindex="0">
                                    <thead>
                                        <tr>
                                            <th scope="col">{{ 'rank' | translate | async }}</th>
                                            <th scope="col">{{ 'mineral.name' | translate | async }}</th>
                                            <th scope="col">{{ 'class' | translate | async }}</th>
                                            <th scope="col">{{ 'economic.mineral.type' | translate | async }}</th>
                                            <th scope="col">{{ 'alteration.mineral.type' | translate | async }}</th>
                                            <th scope="col">{{ 'alteration.ranking' | translate | async }}</th>
                                            <th scope="col">{{ 'alteration.intensity' | translate | async }}</th>
                                            <th scope="col">{{ 'alteration.style' | translate | async }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let mineral of record.mineralization | orderBy: 'economic_ranking'">
                                            <td scope="row" innerHTML="{{ mineral.economic_ranking | notApplicablePipe | async | highlight : this.searchTerms }}">
                                                {{ mineral.economic_ranking | notApplicablePipe | async | highlight : this.searchTerms }}
                                            </td>
                                            <td scope="row" innerHTML="{{ mineral.mineral_name[0].name | highlight : this.searchTerms }}">
                                                {{ mineral.mineral_name[0].name | highlight : this.searchTerms }}
                                            </td>
                                            <td scope="row" innerHTML="{{ mineral.class | notApplicablePipe | async | highlight : this.searchTerms }}">
                                                {{ mineral.class | notApplicablePipe | async | highlight : this.searchTerms }}
                                            </td>
                                            <td scope="row" innerHTML="{{ mineral.economic_mineral_type | notApplicablePipe | async | highlight : this.searchTerms }}">
                                                {{ mineral.economic_mineral_type | notApplicablePipe | async | highlight : this.searchTerms }}
                                            </td>
                                            <ng-container *ngIf="mineral.alteration_mineral_type && mineral.alteration_mineral_type.length > 0; else na">
                                                <td scope="row" innerHTML="{{ mineral.alteration_mineral_type[0].alteration_mineral_type | highlight : this.searchTerms }}">
                                                    {{ mineral.alteration_mineral_type[0].alteration_mineral_type | highlight : this.searchTerms }}
                                                </td>
                                            </ng-container>
                                            <ng-template #na>
                                                <td scope="row">{{ 'na' | translate | async }}</td>
                                            </ng-template>
                                            <td scope="row" innerHTML="{{ mineral.alteration_ranking | notApplicablePipe | async | highlight : this.searchTerms }}">
                                                {{ mineral.alteration_ranking | notApplicablePipe | async | highlight : this.searchTerms }}
                                            </td>
                                            <td scope="row" innerHTML="{{ mineral.intensity | notApplicablePipe | async | highlight : this.searchTerms }}">
                                                {{ mineral.intensity | notApplicablePipe | async | highlight : this.searchTerms }}
                                            </td>
                                            <ng-container *ngIf="mineral.alteration_style && mineral.alteration_style.length > 0; else na">
                                                <td scope="row" innerHTML="{{ mineral.alteration_style[0].name | highlight : this.searchTerms }}">
                                                    {{ mineral.alteration_style[0].name | highlight : this.searchTerms }}
                                                </td>
                                            </ng-container>
                                            <ng-template #na>
                                                <td scope="row">{{ 'na' | translate | async }}</td>
                                            </ng-template>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="this.mineralizationCommentList.length > 0">
                        <h3 class="mb-2">
                            {{ 'mineralization.comments' | translate | async }}
                        </h3>
                        <div>
                            <p *ngFor="let comment of this.mineralizationCommentList" innerHTML="{{ comment.created_at }} ({{ comment.geologist[0].first_name | highlight : this.searchTerms }} {{ comment.geologist[0].last_name | highlight : this.searchTerms }}) - {{ comment.geology_comment | highlight : this.searchTerms }}">
                                {{ comment.created_at }} ({{ comment.geologist[0].first_name | highlight : this.searchTerms }} {{ comment.geologist[0].last_name | highlight : this.searchTerms }}) - {{ comment.geology_comment | highlight : this.searchTerms }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #assaySamplesTable>
            <div>
                <div class="ontario-table-container">
                    <div class="ontario-table-div mb-0">
                        <table class="flex-child" tabindex="0">
                            <thead>
                                <tr>
                                    <th scope="col">{{ 'commodity' | translate | async }}</th>
                                    <th scope="col">{{ 'analytical.method' | translate | async }}</th>
                                    <th scope="col">{{ 'digestion.method' | translate | async }}</th>
                                    <th scope="col">{{ 'result' | translate | async }}</th>
                                    <th scope="col">{{ 'unit' | translate | async }}</th>
                                    <th scope="col">{{ 'limit' | translate | async }}</th>
                                    <th scope="col">{{ 'qualifier' | translate | async }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let assay of assay_samples">
                                    <ng-container *ngIf="assay.commodity && assay.commodity.length > 0; else na">
                                        <td scope="row" innerHTML="{{ assay.commodity[0].description | highlight : this.searchTerms }}">
                                            {{ assay.commodity[0].description | highlight : this.searchTerms }}
                                        </td>
                                    </ng-container>
                                    <ng-template #na>
                                        <td scope="row">{{ 'na' | translate | async }}</td>
                                    </ng-template>
                                    <ng-container *ngIf="assay.analytical_method && assay.analytical_method.length > 0; else na">
                                        <td scope="row" innerHTML="{{ assay.analytical_method[0].name | highlight : this.searchTerms }}">
                                            {{ assay.analytical_method[0].name | highlight : this.searchTerms }}
                                        </td>
                                    </ng-container>
                                    <ng-template #na>
                                        <td scope="row">{{ 'na' | translate | async }}</td>
                                    </ng-template>
                                    <ng-container *ngIf="assay.digestion_method && assay.digestion_method.length > 0; else na">
                                        <td scope="row" innerHTML="{{ assay.digestion_method[0].name | highlight : this.searchTerms }}">
                                            {{ assay.digestion_method[0].name | highlight : this.searchTerms }}
                                        </td>
                                    </ng-container>
                                    <ng-template #na>
                                        <td scope="row">{{ 'na' | translate | async }}</td>
                                    </ng-template>
                                    <td scope="row" innerHTML="{{ assay.result | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ assay.result | notApplicablePipe | async | highlight : this.searchTerms }}
                                    </td>
                                    <td scope="row" innerHTML="{{ assay.unit | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ assay.unit | notApplicablePipe | async | highlight : this.searchTerms }}
                                    </td>
                                    <td scope="row" innerHTML="{{ assay.limit | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ assay.limit | notApplicablePipe | async | highlight : this.searchTerms }}
                                    </td>
                                    <td scope="row" innerHTML="{{ assay.qualifier | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ assay.qualifier | notApplicablePipe | async | highlight : this.searchTerms }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #classificationTable>
            <div>
                <div class="ontario-table-container">
                    <div class="ontario-table-div mb-0">
                        <table class="flex-child" tabindex="0">
                            <thead>
                                <tr>
                                    <th scope="col">{{ 'rank' | translate | async }}</th>
                                    <th scope="col">{{ 'classification' | translate | async }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let classification of record.classifications | orderBy: 'classification_ranking'">
                                    <td scope="row" innerHTML="{{ classification.classification_ranking | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ classification.classification_ranking | notApplicablePipe | async | highlight : this.searchTerms }}</td>
                                    <td scope="row" innerHTML="{{ classification.classification[0].deposit_classification | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ classification.classification[0].deposit_classification | notApplicablePipe | async | highlight : this.searchTerms }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #characteristicsTable>
            <div>
                <div class="ontario-table-container">
                    <div class="ontario-table-div mb-0">
                        <table class="flex-child" tabindex="0">
                            <thead>
                                <tr>
                                    <th scope="col">{{ 'rank' | translate | async }}</th>
                                    <th scope="col">{{ 'characteristic' | translate | async }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let characteristic of record.characteristics | orderBy: 'rank'">
                                    <td scope="row" innerHTML="{{ characteristic.rank | notApplicablePipe | async | highlight : this.searchTerms }}"
                                    >{{ characteristic.rank | notApplicablePipe | async | highlight : this.searchTerms }}
                                </td>
                                    <td scope="row" innerHTML="{{ characteristic.characteristic[0].deposit_characteristic | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ characteristic.characteristic[0].deposit_characteristic | notApplicablePipe | async | highlight : this.searchTerms }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #mineralZoneTable>
            <div>
                <div class="ontario-table-container">
                    <div class="ontario-table-div mb-0">
                        <table class="flex-child" tabindex="0">
                            <thead>
                                <tr>
                                    <th scope="col">{{ 'name' | translate | async }}</th>
                                    <th scope="col">{{ 'rank' | translate | async }}</th>
                                    <th scope="col">{{ 'structure.type' | translate | async }}</th>
                                    <th scope="col">{{ 'shape' | translate | async }}</th>
                                    <th scope="col">{{ 'length' | translate | async }}</th>
                                    <th scope="col">{{ 'thickness' | translate | async }}</th>
                                    <th scope="col">{{ 'depth' | translate | async }}</th>
                                    <th scope="col">{{ 'strike' | translate | async }}</th>
                                    <th scope="col">{{ 'dip' | translate | async }}</th>
                                    <th scope="col">{{ 'plunge' | translate | async }}</th>
                                    <th scope="col">{{ 'trend' | translate | async }}</th>
                                    <th scope="col">{{ 'age' | translate | async }}</th>
                                    <th scope="col">{{ 'reference' | translate | async }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let mineral_zone of record.mineral_zones | orderBy: 'ranking'">
                                    <td scope="row" innerHTML="{{ mineral_zone.name | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ mineral_zone.name | notApplicablePipe | async | highlight : this.searchTerms }}
                                    </td>
                                    <td scope="row" innerHTML="{{ mineral_zone.ranking | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ mineral_zone.ranking | notApplicablePipe | async | highlight : this.searchTerms }}
                                    </td>
                                    <ng-container *ngIf="mineral_zone.zone_structures && mineral_zone.zone_structures.length > 0; else na">
                                        <td scope="row" innerHTML="{{ mineral_zone.zone_structures[0].zone_structure | highlight : this.searchTerms }}">
                                            {{ mineral_zone.zone_structures[0].zone_structure | highlight : this.searchTerms }}
                                        </td>
                                    </ng-container>
                                    <ng-template #na>
                                        <td scope="row">{{ 'na' | translate | async }}</td>
                                    </ng-template>
                                    <ng-container *ngIf="mineral_zone.shape && mineral_zone.shape.length > 0; else na">
                                        <td scope="row" innerHTML="{{ mineral_zone.shape[0].name | highlight : this.searchTerms }}">
                                            {{ mineral_zone.shape[0].name | highlight : this.searchTerms }}
                                        </td>
                                    </ng-container>
                                    <ng-template #na>
                                        <td scope="row">{{ 'na' | translate | async }}</td>
                                    </ng-template>
                                    <td scope="row" innerHTML="{{ mineral_zone.length | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ mineral_zone.length | notApplicablePipe | async | highlight : this.searchTerms }}
                                    </td>
                                    <td scope="row" innerHTML="{{ mineral_zone.thickness | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ mineral_zone.thickness | notApplicablePipe | async | highlight : this.searchTerms }}
                                    </td>
                                    <td scope="row" innerHTML="{{ mineral_zone.depth | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ mineral_zone.depth | notApplicablePipe | async | highlight : this.searchTerms }}
                                    </td>
                                    <td scope="row" innerHTML="{{ mineral_zone.strike | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ mineral_zone.strike | notApplicablePipe | async | highlight : this.searchTerms }}
                                    </td>
                                    <td scope="row" innerHTML="{{ mineral_zone.dip | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ mineral_zone.dip | notApplicablePipe | async | highlight : this.searchTerms }}
                                    </td>
                                    <td scope="row" innerHTML="{{ mineral_zone.plunge | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ mineral_zone.plunge | notApplicablePipe | async | highlight : this.searchTerms }}
                                    </td>
                                    <td scope="row" innerHTML="{{ mineral_zone.trend | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ mineral_zone.trend | notApplicablePipe | async | highlight : this.searchTerms }}
                                    </td>
                                    <td scope="row" innerHTML="{{ mineral_zone.age | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ mineral_zone.age | notApplicablePipe | async | highlight : this.searchTerms }}
                                    </td>
                                    <td scope="row" innerHTML="{{ mineral_zone.reference | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ mineral_zone.reference | notApplicablePipe | async | highlight : this.searchTerms }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #siteVisitDetails>
            <div>
                <div class="ontario-table-container">
                    <div class="ontario-table-div mb-0">
                        <table class="flex-child" tabindex="0">
                            <thead>
                                <tr>
                                    <th scope="col">{{ 'date' |translate | async }}</th>
                                    <th scope="col">{{ 'geologist' |translate | async }}</th>
                                    <th scope="col">{{ 'notes' |translate | async }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let site_visit of record.site_visits">
                                    <td scope="row" innerHTML="{{ site_visit.visit_date | date: 'YYYY-MM-dd' }}">
                                        {{ site_visit.visit_date | date: 'YYYY-MM-dd' }}
                                    </td>
                                    <td scope="row" innerHTML="{{ site_visit.geologist[0].first_name | highlight : this.searchTerms }} {{ site_visit.geologist[0].last_name | highlight : this.searchTerms }}">
                                        {{ site_visit.geologist[0].first_name | highlight : this.searchTerms }} {{ site_visit.geologist[0].last_name | highlight : this.searchTerms }}
                                    </td>
                                    <td scope="row" innerHTML="{{ site_visit.visit_comment | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ site_visit.visit_comment | notApplicablePipe | async | highlight : this.searchTerms }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #reservesTable>
            <div>
                <div class="ontario-table-container">
                    <div class="ontario-table-div mb-0">
                        <table class="flex-child" tabindex="0">
                            <thead>
                                <tr>
                                    <th scope="col">{{ 'zone' | translate | async }}</th>
                                    <th scope="col">{{ 'year' | translate | async }}</th>
                                    <th scope="col">{{ 'category' | translate | async }}</th>
                                    <th scope="col">{{ 'tonnes' | translate | async }}</th>
                                    <th scope="col">{{ 'reference' | translate | async }}</th>
                                    <th scope="col">{{ 'comments' | translate | async }}</th>
                                    <th scope="col">{{ 'commodities' | translate | async }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let reserve of record.reserves | orderBy: 'year':true">
                                    <td scope="row" innerHTML="{{ reserve.ore_zone | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ reserve.ore_zone | notApplicablePipe | async | highlight : this.searchTerms }}
                                    </td>
                                    <td scope="row" innerHTML="{{ reserve.year | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ reserve.year | notApplicablePipe | async | highlight : this.searchTerms }}
                                    </td>
                                    <ng-container *ngIf="reserve.category && reserve.category.length > 0; else na">
                                        <td scope="row" innerHTML="{{ reserve.category[0].resourcemd_category | highlight : this.searchTerms }}">
                                            {{ reserve.category[0].resourcemd_category | highlight : this.searchTerms  }}
                                        </td>
                                    </ng-container>
                                    <ng-template #na>
                                        <td scope="row">{{ 'na' | translate | async }}</td>
                                    </ng-template>
                                    <td scope="row" innerHTML="{{ reserve.tonnes | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ reserve.tonnes | notApplicablePipe | async | highlight : this.searchTerms }}</td>
                                    <td scope="row" innerHTML="{{ reserve.reference | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ reserve.reference | notApplicablePipe | async | highlight : this.searchTerms }}</td>
                                    <td scope="row" innerHTML="{{ reserve.comments | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ reserve.comments | notApplicablePipe | async | highlight : this.searchTerms }}</td>
                                    <td scope="row" innerHTML="{{ reserve.commodities | commaSeparatedPipe:'commodity' | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ reserve.commodities | commaSeparatedPipe:'commodity' | notApplicablePipe | async  | highlight : this.searchTerms }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #productionTable>
            <div>
                <div>
                    <div class="ontario-table-container">
                        <div class="ontario-table-div mb-0">
                            <table class="flex-child" tabindex="0">
                                <thead>
                                    <tr>
                                        <th scope="col">{{ 'year.from' | translate | async }}</th>
                                        <th scope="col">{{ 'year.to' | translate | async }}</th>
                                        <th scope="col">{{ 'tonnes' | translate | async }}</th>
                                        <th scope="col">{{ 'commodities' | translate | async }}</th>
                                        <th scope="col">{{ 'reference' | translate | async }}</th>
                                        <th scope="col">{{ 'comment' | translate | async }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let prod of record.production">
                                        <td scope="row" innerHTML="{{ prod.year_from | notApplicablePipe | async }}">
                                            {{ prod.year_from | notApplicablePipe | async }}
                                        </td>
                                        <td scope="row" innerHTML="{{ prod.year_to | notApplicablePipe | async }}">
                                            {{ prod.year_to | notApplicablePipe | async }}
                                        </td>
                                        <td scope="row" innerHTML="{{ prod.tonnes | notApplicablePipe | async | highlight : this.searchTerms }}">
                                            {{ prod.tonnes | notApplicablePipe | async | highlight : this.searchTerms }}
                                        </td>
                                        <td scope="row">
                                            <ng-container *ngIf="prod.commodities && prod.commodities.length > 0; else na">
                                                <p *ngFor="let commodity of prod.commodities">
                                                    {{ commodity.description }} {{ commodity.commodity_mass }} {{ commodity.unit_of_measure }}
                                                </p>
                                            </ng-container>
                                            <ng-template #na>
                                                <p>{{ 'na' | translate | async }}</p>
                                            </ng-template>
                                        </td>
                                        <td scope="row" innerHTML="{{ prod.source | notApplicablePipe | async | highlight : this.searchTerms }}">
                                            {{ prod.source | notApplicablePipe | async | highlight : this.searchTerms }}
                                        </td>
                                        <td scope="row" innerHTML="{{ prod.comments | notApplicablePipe | async | highlight : this.searchTerms }}">
                                            {{ prod.comments | notApplicablePipe | async | highlight : this.searchTerms }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #referencesDetails>
            <div>
                <div class="ontario-table-container">
                    <div class="ontario-table-div mb-0">
                        <table class="flex-child" tabindex="0">
                            <thead>
                                <tr>
                                    <th scope="col">{{ 'title' | translate | async }}</th>
                                    <th scope="col">{{ 'publication.number' | translate |async }}</th>
                                    <th scope="col">{{ 'page' | translate | async }}</th>
                                    <th scope="col">{{ 'date' | translate | async }}</th>
                                    <th scope="col">{{ 'author' | translate | async }}</th>
                                    <th scope="col">{{ 'publisher' | translate | async }}</th>
                                    <th scope="col">{{ 'location' | translate | async }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let reference of record.references">
                                    <td scope="row" innerHTML="{{ reference.title | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ reference.title | notApplicablePipe | async | highlight : this.searchTerms }}
                                    </td>
                                    <td scope="row">
                                        <ng-container *ngIf="reference.ogs_publ == 1; else noOgsPubl">
                                            <a target="_blank" 
                                                innerHTML="{{ reference.publ_num | notApplicablePipe | async | highlight : this.searchTerms }}"
                                                href="{{this.publicationPersistentLink}}{{reference.publ_num}}">
                                                {{ reference.publ_num | notApplicablePipe | async | highlight : this.searchTerms }}
                                            </a>                                            
                                        </ng-container>
                                        <ng-template #noOgsPubl>
                                            {{ reference.publ_num | notApplicablePipe | async | highlight : this.searchTerms }}
                                        </ng-template>
                                    </td>
                                    <td scope="row" innerHTML="{{ reference.page_number | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ reference.page_number | notApplicablePipe | async | highlight : this.searchTerms }}
                                    </td>
                                    <td scope="row" innerHTML="{{ reference.release_date | date: 'yyyy' | notApplicablePipe | async }}">
                                        {{ reference.release_date | date: 'yyyy' | notApplicablePipe | async }}
                                    </td>
                                    <td scope="row" innerHTML="{{ reference.originator | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ reference.originator | notApplicablePipe | async | highlight : this.searchTerms }}
                                    </td>
                                    <td scope="row" innerHTML="{{ reference.publisher | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ reference.publisher | notApplicablePipe | async | highlight : this.searchTerms }}
                                    </td>
                                    <td scope="row" innerHTML="{{ reference.location | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ reference.location | notApplicablePipe | async | highlight : this.searchTerms }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </ng-template>

    </div>

    <!-- Scroll Button -->
    <button onClick="scrollToTop()" class="ontario-back-to-top--default">
        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
            <use href="#ontario-icon-arrow-up"></use>
        </svg>
        {{ 'top' | translate | async }}
    </button>
    
</div>